/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { MultipleSelect, SelectButton } from "@nordcloud/gnui";
import { InlineEditForm } from "~/components/InlineEdit/InlineEditForm";
import { displayYesOrNo } from "~/tools";

type Props = {
  trueLabel?: string;
  falseLabel?: string;
  defaultValue: boolean;
  onSubmit: (value: boolean) => Promise<void>;
  canEdit?: boolean;
};

function InlineEditSwitch({
  trueLabel = "Enabled",
  falseLabel = "Disabled",
  defaultValue,
  onSubmit,
  canEdit,
}: Props) {
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue);
  }, [setValue, defaultValue]);

  return (
    <InlineEditForm
      onSubmit={async () => onSubmit(value)}
      display={displayYesOrNo(defaultValue)}
      canEdit={canEdit}
    >
      <MultipleSelect size="small">
        <SelectButton
          name="button1"
          value={falseLabel}
          labelText={trueLabel}
          isActive={value}
          onClick={() => setValue(true)}
        />
        <SelectButton
          name="button2"
          value={trueLabel}
          labelText={falseLabel}
          isActive={!value}
          onClick={() => setValue(false)}
        />
      </MultipleSelect>
    </InlineEditForm>
  );
}

export { InlineEditSwitch };
